import React, { Component } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import MyHistoryReviewCase from './my-history-review-case'

export default class HistoryReviewCase extends Component {
    render() {
        return (
            <Switch>
                <Route path='/fixcomputer/historyreviewcase' component={MyHistoryReviewCase} exact /> {/*exact = 路徑完全匹配*/}
                <Redirect to='/fixcomputer/historyreviewcase' />
            </Switch>
        )
    }
}